import React from 'react';
import { Space, Spin } from 'antd';

import { LoadingOutlined as LoadingIcon } from '../Icons';

import { type SpinSize } from 'antd/lib/spin';

import styles from './loader.module.scss';

interface IProps {
  className?: string;
  text?: string;
  size?: SpinSize;
}

export const Loader: React.FC<IProps> = (props) => {
  const { className = '', text = '', size = 'large' } = props;

  return (
    <Space className={className ?? styles.space}>
      <Spin
        size={size}
        className={styles.spin}
        tip={text}
        indicator={<LoadingIcon className={styles.icon} />}
      />
    </Space>
  );
};
